import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { searchProducts } from '@dfq/shared/api/products';
import type { SearchSuggestion } from '@dfq/shared/components/SearchBar';
import { SearchBar } from '@dfq/shared/components/SearchBar';
import { useAppDispatch } from '@dfq/shared/hooks/useStore';
import { clearSearch, setQuery } from '@dfq/shared/stores/search';

import { storefrontRoutePaths } from '@/router/paths';

/** Wires SearchBar to the search slice and React Router. SF-SEARCH-003. */
export function SearchBarContainer() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const fetchSuggestions = useCallback(async (query: string): Promise<SearchSuggestion[]> => {
    const result = await searchProducts({ q: query, perPage: 6 });
    return result.items;
  }, []);

  const handleSubmit = useCallback(
    (query: string) => {
      dispatch(setQuery(query));
      navigate(`${storefrontRoutePaths.search}?q=${encodeURIComponent(query)}`);
    },
    [dispatch, navigate],
  );

  const handleSelectSuggestion = useCallback(
    (suggestion: SearchSuggestion) => {
      const categorySlug = suggestion.category_slug ?? 'products';
      navigate(storefrontRoutePaths.catalog.product(categorySlug, suggestion.slug));
    },
    [navigate],
  );

  const handleClear = useCallback(() => {
    dispatch(clearSearch());
  }, [dispatch]);

  return (
    <SearchBar
      fetchSuggestions={fetchSuggestions}
      onSubmit={handleSubmit}
      onSelectSuggestion={handleSelectSuggestion}
      onClear={handleClear}
    />
  );
}
